export enum ApiRoutesDeliveryPriority {
  DeliveryPriority = "admin/delivery-priority"
}
